import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = guest, object = logged in
  const [authModal, setAuthModal] = useState(null); // null | "login" | "register"

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch {
        try {
          await api.post("/auth/refresh");
          const r = await api.get("/auth/me");
          setUser(r.data);
        } catch {
          setUser(false);
        }
      }
    })();
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
    setAuthModal(null);
    return r.data;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setUser(r.data);
    setAuthModal(null);
    return r.data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  const openAuth = (mode = "register") => setAuthModal(mode);
  const closeAuth = () => setAuthModal(null);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, authModal, openAuth, closeAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
